const STATUS_CHANGE_PATTERN = /^(\w+)\s*→\s*(\w+)$/;

export function formatActivityBody(activity, t, { entry, latestLostActivityId } = {}) {
  const body = activity?.body;
  if (!body) return null;

  if (activity.type === 'status_change' || activity.type === 'system') {
    const match = body.match(STATUS_CHANGE_PATTERN);
    if (match) {
      const [, fromKey, toKey] = match;
      const lines = [
        t('leads.statusChangeBody', {
          from: t(`leads.status.${fromKey}`),
          to: t(`leads.status.${toKey}`),
        }),
      ];

      if (toKey === 'lost') {
        const useEntryFallback = !activity.lostReason
          && latestLostActivityId
          && String(activity._id) === String(latestLostActivityId);
        const reasonKey = activity.lostReason || (useEntryFallback ? entry?.lostReason : '');
        const noteText = activity.lostNote || (useEntryFallback ? entry?.lostNote : '');

        if (reasonKey) {
          lines.push(t('leads.lostReasonInActivity', {
            reason: t(`leads.lostReason.${reasonKey}`),
          }));
        }
        if (noteText && String(noteText).trim()) {
          lines.push(String(noteText).trim());
        }
      }

      return lines.join('\n');
    }
  }

  return body;
}
